/* unplugin-vue-components disabled */import script from "./Reward.vue?vue&type=script&setup=true&lang=js"
export * from "./Reward.vue?vue&type=script&setup=true&lang=js"

import "./Reward.vue?vue&type=style&index=0&id=0081a731&lang=less"

const __exports__ = script;

export default __exports__